import type { RemixIconSize } from "../../general/RemixIcon/RemixIcon";

export type GlaSelectorSize = "xs" | "sm" | "l";

export interface GlaSelectorTriggerSizeClasses {
    button: string;
    triggerIcon: string;
    chevron: string;
    chevronInset: string;
    pillWrapper: string;
    pillIconGap: string;
    pillIconSize: RemixIconSize;
    pillLabel: string;
    clearIcon: string;
}

export const TRIGGER_SIZE_CLASSES: Record<GlaSelectorSize, GlaSelectorTriggerSizeClasses> = {
    xs: {
        button: "h-8 min-h-8 max-h-8 gap-1.5 overflow-hidden py-0 pl-2 pr-7 text-xs",
        triggerIcon: "size-3.5",
        chevron: "size-3.5",
        chevronInset: "pr-2",
        pillWrapper: "h-8 min-h-8 max-h-8 gap-0.5 overflow-hidden py-0 pl-1 pr-1",
        pillIconGap: "min-w-0 flex-1 gap-1",
        pillIconSize: "xs",
        pillLabel: "text-xs leading-none",
        clearIcon: "size-3.5",
    },
    sm: {
        button: "h-9 min-h-9 max-h-9 gap-1.5 overflow-hidden py-0 pl-2.5 pr-8 text-sm",
        triggerIcon: "size-4",
        chevron: "size-4",
        chevronInset: "pr-2.5",
        pillWrapper: "h-9 min-h-9 max-h-9 gap-0.5 overflow-hidden py-0 pl-1.5 pr-1.5",
        pillIconGap: "min-w-0 flex-1 gap-1.5",
        pillIconSize: "xs",
        pillLabel: "text-sm leading-none",
        clearIcon: "size-4",
    },
    l: {
        button: "h-10 min-h-10 max-h-10 gap-2 overflow-hidden py-0 pl-3 pr-10 text-sm",
        triggerIcon: "size-5",
        chevron: "size-4",
        chevronInset: "pr-3",
        pillWrapper: "h-10 min-h-10 max-h-10 gap-0.5 overflow-hidden py-0 pl-2 pr-2",
        pillIconGap: "min-w-0 flex-1 gap-2",
        pillIconSize: "xs",
        pillLabel: "text-sm leading-none",
        clearIcon: "size-4",
    },
};

export function getTriggerSizeClasses(size: GlaSelectorSize = "l"): GlaSelectorTriggerSizeClasses {
    return TRIGGER_SIZE_CLASSES[size];
}
